export function getResponseErrorMessage(error) {
  if ("response" in error) {
    const {
      response: { data },
    } = error;

    if (typeof data.error !== "string") {
      if (Array.isArray(data.error)) {
        return data.error[0].msg;
      }
      return data.error.error || data.error.detalhamento.mensagem;
    }

    const strError = data.error.replace(/[\n{}]/g, "").trim();
    let message;

    for (let value of strError.split(",")) {
      if (value.indexOf("message") !== -1) {
        message = value.split(":")[1];
        break;
      }
    }

    if (!message) message = data.message;

    return message.replace(/"/g, "");
  }

  return error.message;
}
